import { render, staticRenderFns } from "./ReviewerManagement.vue?vue&type=template&id=9cec1032&scoped=true"
import script from "./ReviewerManagement.vue?vue&type=script&lang=js"
export * from "./ReviewerManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cec1032",
  null
  
)

export default component.exports